__turbopack_context__.v({
  "Description": "gW1A4G_Description",
  "Icon": "gW1A4G_Icon",
  "IconBefore": "gW1A4G_IconBefore",
  "IconHover": "gW1A4G_IconHover",
  "IconWrapper": "gW1A4G_IconWrapper",
  "Root": "gW1A4G_Root",
  "Root--Active": "gW1A4G_Root--Active",
  "Root--Arrow": "gW1A4G_Root--Arrow",
  "Root--Dark": "gW1A4G_Root--Dark",
  "Root--Disabled": "gW1A4G_Root--Disabled",
  "Root--Filter": "gW1A4G_Root--Filter",
  "Root--FilterAlternative": "gW1A4G_Root--FilterAlternative",
  "Root--FullWidth": "gW1A4G_Root--FullWidth",
  "Root--Large": "gW1A4G_Root--Large",
  "Root--Loading": "gW1A4G_Root--Loading",
  "Root--Primary": "gW1A4G_Root--Primary",
  "Root--Save": "gW1A4G_Root--Save",
  "Root--Secondary": "gW1A4G_Root--Secondary",
  "Root--SecondaryDarkGrey": "gW1A4G_Root--SecondaryDarkGrey",
  "Root--SecondaryGrey": "gW1A4G_Root--SecondaryGrey",
  "Root--Small": "gW1A4G_Root--Small",
  "Root--Toggle": "gW1A4G_Root--Toggle",
  "Root--ToggleGrey": "gW1A4G_Root--ToggleGrey",
  "Title": "gW1A4G_Title",
  "skeleton-loading": "gW1A4G_skeleton-loading",
});
